import React from 'react';

import { TextField, TextFieldProps } from './text-input.component';

const PasswordField = ({ isRequired = true, ...rest }: TextFieldProps) => (
    <TextField type="password" isRequired {...rest} />
);

export { PasswordField };
